/**
 * Slottermijn percentage and default calculators for lease.
 * Shared module used by lease-calculator block and car-single form.
 */

/**
 * Get maximum slottermijn percentage based on looptijd (zakelijk only).
 *
 * @param {number} looptijd Lease term in months.
 * @param {number} type Lease type: 0 = Zakelijk. Optional, defaults to 0.
 * @returns {number} Percentage as decimal (e.g., 0.60 for 60%).
 */
export function getSlottermijnPercentage( looptijd, type = 0 ) {
	const looptijdNum = Number( looptijd ) || 0;

	if ( looptijdNum <= 12 ) {
		return 0.60; // 60%
	}
	if ( looptijdNum <= 24 ) {
		return 0.50; // 50%
	}
	if ( looptijdNum <= 36 ) {
		return 0.45; // 45%
	}
	if ( looptijdNum <= 48 ) {
		return 0.35; // 35%
	}
	if ( looptijdNum <= 60 ) {
		return 0.25; // 25%
	}
	if ( looptijdNum <= 72 ) {
		return 0.20; // 20%
	}

	return 0.20;
}

/**
 * Calculate default slottermijn based on looptijd and resterend bedrag (zakelijk only).
 *
 * @param {number} resterendBedrag Remaining financing amount (aankoopbedrag - aanbetaling).
 * @param {number} looptijd Lease term in months.
 * @param {number} type Lease type: 0 = Zakelijk. Optional, defaults to 0.
 * @returns {number} Default slottermijn amount.
 */
export function getDefaultSlottermijnForType( resterendBedrag, looptijd, type = 0 ) {
	const base = Number( resterendBedrag || 0 );
	const percentage = getSlottermijnPercentage( looptijd, type );
	return Math.round( base * percentage );
}
